<div class="title_div">
  <div class="w-100 d-flex justify-content-between align-items-center">

    <div class="proj_id d-flex">
      <div class="title_sub_div_1 mt-1">Part Information :{{projectName}} - Version : {{ version_id }}</div>
    </div>

    <div class="title_sub_div_1  mr-1">
      <button class="btn btn-light btn-sm mr-4" title="Export as Excel" (click)="exportData()">
        <i class="fas fa-file-export"></i> Export
      </button>
      <i class="fa fa-refresh mr-2" (click)="refreshPage()" title="Refresh Part Information data"></i>
      <i class="fa fa-home mr-2" (click)="home()" title="Dashboard"></i> <!-- Home icon here -->
      <i class="fa fa-arrow-left" (click)="back()" title="Go on part view page"></i> <!-- back icon here -->
    </div>
  </div>
</div>

<div class="d-flex justify-content-start">
  <div class="form-group card" title="{{internalPartNo}}">
    <div class="custom-card-medium custom-card-high-risk-parts">
      <div class="custom-card-content-small">
        <div class="custom-card-text-small">{{internalPartNo}}</div>
        <div class="custom-card-text-small"><b>Internal Part No.</b></div>
      </div>
    </div>
  </div>

  <!-- Card for Quantity -->
  <div class="form-group card" title="{{projectQty | number:'1.2-2'}}">
    <div class="custom-card-small custom-card-overdue">
      <div class="custom-card-content-small">
        <div class="custom-card-text-small">{{projectQty | number:'1.2-2'}}</div>
        <div class="custom-card-text-small"><b>Quantity</b></div>
      </div>
    </div>
  </div>

  <!-- Card for Make Filter -->
  <div class="form-group card">
    <div class="custom-card-medium custom-card-high-risk-parts">
      <select id="customerName" class="form-select form-select-lg" aria-label="Select Customer Name"
        [(ngModel)]="selectedManufacturer" (change)="onManufacturerChange()">
        <option value="" disabled selected>Select Make</option>
        <option *ngFor="let make of manufacturerDetails" [value]="make">{{ make }}</option>
      </select>
    </div>
  </div>

  <div class="form-group card" title="{{ specification }}">
  <div class="custom-card-medium custom-card-high-risk-parts">
    <div class="custom-card-content-small">
      <div class="custom-card-text-small">
        {{ specification }}
      </div>
      <div class="custom-card-text-small">
        <b>Specification</b>
      </div>
    </div>
  </div>
</div>


  <!-- Card for Criteria -->
  <div class="form-group card" (click)="selectCriteria(criteriaModal)">
    <div class="custom-card-small custom-card-open-projects">
      <div class="custom-card-content-small">
        <div class="custom-card-text-small">Criteria</div>
      </div>
    </div>
    <ng-template #criteriaModal let-modal>
      <div class="modal-header">
        <h6 class="modal-title">Criteria</h6>
        <div type="button" title="Close" (click)="closeModal()" style="font-size: 32px; ">&times;</div>
      </div>
      <div class="modal-body">
        <div class="main-div flex-wrap">
          <div class="form-group modalformGroup">
            <label>
              <input type="checkbox" [(ngModel)]="criteria.stockAvailability" disabled />
              Stock Availability
            </label>
          </div>

          <div class="form-group modalformGroup">
            <label>
              <input type="checkbox" [(ngModel)]="criteria.leadTime" disabled />
              Lead Time
            </label>
          </div>

          <div class="form-group modalformGroup">
            <label>
              <input type="checkbox" [(ngModel)]="criteria.minimumPrice" disabled />
              Minimum Price
            </label>
          </div>
          <div class="form-group modalformGroup">
            <label>
              <input type="checkbox" [(ngModel)]="criteria.authorisedSuppliers" disabled />
              Authorised suppliers
            </label>
          </div>

          <div class="custom-supplier-container">
            <label for="supplierSelection" class="custom-supplier-label">Supplier Selection:</label>
            <ng-select [items]="supplierOptions" [(ngModel)]="criteria.selectedSuppliers" [multiple]="true"
              bindLabel="name" bindValue="name" class="custom-supplier-ng-select" [readonly]="true">
              <ng-template ng-label-tmp let-item="item" let-clear="clear">
                <span class="custom-supplier-selected">{{ item.name }}</span>           
              </ng-template>
            </ng-select>
          </div>


        </div>
      </div>
    </ng-template>
  </div>



  <div class="popup-backdrop" *ngIf="showSpecsDetails">
    <div class="popup-content">
      <div class="popup-header">
        <h6 class="mb-0">Specifications</h6>
        <div type="button" class="close" (click)="closeSpecificationDetails()" style="font-size: 32px;">&times;</div>
      </div>

      <div class="table-scroll">
        <table class="specs-table">
          <thead>
            <tr>
              <th>Attribute Name</th>
              <th>ID</th>
              <th>Short Name</th>
              <th>Unit Name</th>
              <th>Unit Symbol</th>
              <th>Group</th>
              <th>Value Type</th>
              <th>Unit</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let spec of selectedSpecs">
              <td>{{ spec.name }}</td>
              <td>{{ spec.id }}</td>
              <td>{{ spec.shortname }}</td>
              <td>{{ spec.unitsName }}</td>
              <td>{{ spec.unitsSymbol }}</td>
              <td>{{ spec.group }}</td>
              <td>{{ spec.valueType }}</td>
              <td>{{ spec.unitsSymbol }}</td>
              <td>{{ spec.value }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Card for Description -->
  <div class="form-group card" title="{{description}}">
    <div class="custom-card-medium custom-card-high-risk-parts">
      <div class="custom-card-content-small">
        <div class="custom-card-text-small">{{description}}</div>
        <div class="custom-card-text-small"><b>Description</b></div>
      </div>
    </div>
  </div>
 
</div>
<div *ngIf="infoMessage" class="alert alert-info">
  {{ infoMessage }}
</div>


<div class="row row_mar mt-1">
  <div class="col-12 grid-margin stretch-card col_pad">
    <div class="card">
      <div class="card-body">
        <div class="table-responsive gd_main_div_mobile">
          <table class="table table-striped custom-hover">
            <thead>
              <tr>
                <th></th>
                <th (click)="sortData('supplier')">
                  Supplier
                  <i [ngClass]="getSortIcon('supplier')"></i>
                </th>
                <th (click)="sortData('sourcingType')">
                  Sourcing Type
                  <i [ngClass]="getSortIcon('sourcingType')"></i>
                </th>             

                <th (click)="sortData('country')">
                  Country
                  <i [ngClass]="getSortIcon('country')"></i>
                </th>
                <th (click)="sortData('manufacturer')">
                  Make
                  <i [ngClass]="getSortIcon('manufacturer')"></i>
                </th>
                <th (click)="sortData('MPN')">
                  MPN
                  <i [ngClass]="getSortIcon('MPN')"></i>
                </th>
                <th (click)="sortData('Inventorylevel')">
                  Available Stock
                  <i [ngClass]="getSortIcon('Inventorylevel')"></i>
                </th>
                <th (click)="sortData('Price')">
                  Basic Price
                  <i [ngClass]="getSortIcon('Price')"></i>
                </th>

                <th (click)="sortData('Currency')">
                  Currency
                  <i [ngClass]="getSortIcon('Currency')"></i>
                </th>
                <th (click)="sortData('ConvertedPrice')">
                  Basic Price(INR)
                  <i [ngClass]="getSortIcon('ConvertedPrice')"></i>
                </th>
                <th (click)="sortData('MOQ')">
                  MOQ
                  <i [ngClass]="getSortIcon('MOQ')"></i>
                </th>
                <th (click)="sortData('Closest Quantity')">
                  SPQ
                  <i [ngClass]="getSortIcon('Closest Quantity')"></i>
                </th>
                <th (click)="sortData('leadTime')">
                  Lead Time
                  <i [ngClass]="getSortIcon('leadTime')"></i>
                </th>
                <th (click)="sortData('Landing_cost')">
                  Est. Landing Cost
                  <i [ngClass]="getSortIcon('Landing_cost')"></i>
                </th>
                <th (click)="sortData('Total_landing_cost')">
                  Total Landing Cost
                  <i [ngClass]="getSortIcon('Total_landing_cost')"></i>
                </th>

                <th (click)="sortData('Total_est_Cost')">
                  Total Est. Landing Cost(INR)
                  <i [ngClass]="getSortIcon('Total_est_Cost')"></i>
                </th>
                <th>
                  Actions
                </th>

              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of filteredSourceInfoData; let i = index" [class.selected]="selectedRowIndex === i">
                <td style="padding:0;">
                  <i class="fas fa-check-square check-icon"
                    [ngStyle]="{'color': data.isAuthorized ? 'blue' : 'lightgrey'}">
                  </i>
                </td>
                <td title="{{ data?.supplier }}">
                  <ng-container *ngIf="data?.clickUrl; else noLink">
                    <a [href]="data.clickUrl" target="_blank" rel="noopener noreferrer">
                      {{ data?.supplier }}
                    </a>
                  </ng-container>
                  <ng-template #noLink>
                    {{ data?.supplier }}
                  </ng-template>
                </td>


                <td (click)="openDatasheet(data)" [ngStyle]="{
      'color': data?.sourcingType === 'offline' ? 'orange' : (data?.sourcingType === 'vendor' ? 'rgb(0, 128, 0)' : (data?.sourcingType === 'nexar' ? '#0d6efd' : 'inherit')),
      'text-decoration': data?.DatasheetURL ? 'underline' : 'none',
      'cursor': data?.DatasheetURL ? 'pointer' : 'default'
    }" [ngClass]="{
      'fw-bold': data?.sourcingType === 'offline' || data?.sourcingType === 'nexar' || data?.sourcingType === 'vendor',
      'text-primary': data?.sourcingType === 'nexar'
    }" title="{{ data?.sourcingType }}">
                 
                  {{
                  data?.sourcingType === 'offline' ? 'Offline' :
                  data?.sourcingType === 'nexar' ? 'Consolidator' :
                  data?.sourcingType === 'vendor' ? 'Direct' : data?.sourcingType
                  }}
                </td>

                <td title="{{data?.country}}">
                  {{ data?.country }}

                </td>

                <td class="position-relative" title="{{data?.manufacturer}}">{{
                  data?.manufacturer }}

                </td>
                <td title="{{data?.MPN}}">{{ data?.MPN }}</td>
                <td title="{{data?.Inventorylevel}}">{{ data?.Inventorylevel }}</td>
                <td title="{{data?.Price}}">
                  {{ data?.Price }}
                 
                </td>
                <td title="{{data?.Currency}}">{{ data?.Currency }}</td>             
                <td title="{{data?.ConvertedPrice}}">{{ data?.ConvertedPrice | number:'1.2-2' }}</td>
                <td title="{{data?.MOQ}}">{{ data?.MOQ }}</td>
                <td title="{{data?.Closest_Quantity}}">{{ data?.Closest_Quantity}}</td>
                <td title="{{data?.estimatedFactoryLeadDays}}">{{ data?.estimatedFactoryLeadDays | number:'1.2-2' }}</td>
                <td title="{{data?.LandingCost}}">{{ data?.LandingCost | number:'1.2-2' }}</td>
                <td title="{{data?.Total_landing_cost}}">{{ data?.Total_landing_cost | number:'1.2-2' }}</td>
                <td title="{{data?.Total_est_Cost}}">{{ data?.Total_est_Cost | number:'1.2-2' }}</td>
         

<td class="d-flex align-items-center justify-content-start" style="padding-left: 6px; min-width: 80px;">
  <!-- Info Icon First -->
  <i class="fa-solid fa-circle-info text-primary info-icon"
     (click)="onClickOfferPrice(offerPriceModal, data)"
     title="Price Information"></i>

  <!-- Eye Icon Next -->
  <ng-container *ngIf="data?.Specs && data.Specs.length">
    <i class="fa-solid fa-eye eye-icon text-secondary"
       (click)="specificationDetails(data)"
       title="View Specifications"></i>
  </ng-container>
</td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
  </div>
</div>

<div class="footer-section">
  <div class="d-flex justify-content-start">
 

<div class="form-group card" (click)="getProcurementHistory()">
  <div class="custom-card-small custom-card-open-projects">
    <div class="custom-card-content-medium">
      <div class="custom-card-text-small">Procurement History</div>
    </div>
  </div>
</div>

    <!-- Card for Inventory History -->
    <div class="form-group card">
      <div class="custom-card-small custom-card-open-projects">
        <div class="custom-card-content-medium">
          <div class="custom-card-text-small">Inventory History</div>
        </div>
      </div>
    </div>

    

    <div class="form-group card" (click)="onCardClick()">
      <div class="custom-card-small custom-card-open-projects">
        <div class="custom-card-content-medium">
          <div class="risk-container">
            <div class="custom-card-text-small"> Risk AI</div>
            <img class="risk-analysis" src="assets/images/ai.png" alt="logo" />
          </div>

        </div>
      </div>
    </div>

    <div *ngIf="showPopup" class="custom-name">
      <div class="popup-name">

        <div class="popup-headertop">
          <div type="button" class="close" (click)="closePopup()">&times;</div>
        </div>

        <div class="popup-body">
          <div *ngIf="!cleanedResHTML" class="loading">
            <div class="spinner"></div>
            <p style="color: green;">Fetching Risk AI</p>
          </div>

          
          <div id="risk-analysis-table" [innerHTML]="cleanedResHTML"></div>

        </div>

      </div>
    </div>


    <div class="form-group card">
      <div class="custom-card-small custom-card-open-projects">
        <div class="custom-card-content-medium">
          <div class="custom-card-text-small">Alternative</div>
        </div>
      </div>
    </div>

   
    <div class="form-group card" (click)="openAddPartModal()">
      <div class="custom-card-small custom-card-high-risk-parts">
        <div class="custom-card-content-medium">
          <div class="custom-card-text-small">Part Alert</div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Add Part Modal -->
<ng-template #addPartModal let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Add Part Number</h6>
  </div>
  <div class="form-group modalformGroup">
    <div class="container">
      <form [formGroup]="partForm">
        <div class="row g-3">

          <div class="col-md-4">
            <label for="projectName" class="form-label">Project Name</label>
            <input type="text" id="projectName" class="form-control" formControlName="projectName" />
          </div>

          <div class="col-md-4">
            <label for="internalPartNo" class="form-label">Internal Part No.</label>
            <input type="text" id="internalPartNo" class="form-control" formControlName="internalPartNo" />
          </div>

          <div class="col-md-4">
            <label for="MPN" class="form-label">MPN</label>
            <input type="text" id="MPN" class="form-control" formControlName="MPN" />
          </div>

          <div class="col-md-4">
            <label for="uom" class="form-label">UOM</label>
            <input type="text" id="uom" class="form-control" formControlName="uom" />
          </div>

          <div class="col-md-4">
            <label for="requiredQuantity" class="form-label">Required Quantity</label>
            <input type="number" id="requiredQuantity" class="form-control" formControlName="requiredQuantity" />
          </div>

          <div class="col-md-4">
            <label for="frequency" class="form-label">Frequency</label>
            <select id="frequency" class="form-control" formControlName="frequency">
              <option *ngFor="let option of frequencyOptions" [ngValue]="option">
                {{ option.scheduleType }}
              </option>
            </select>
          </div>
          <div class="col-md-12 mt-3" formGroupName="sourcingType">
            <label class="form-label">Sourcing Type</label>
            <div class="sourcing-type-group">
          
              <div class="form-check" *ngFor="let type of ['nexar', 'vendor', 'offline']">
                <input type="checkbox" class="form-check-input" [id]="type" [formControlName]="type" />
                <label class="form-check-label text-capitalize" [for]="type">
                  {{
                  {
                  'nexar': 'Consolidator',
                  'vendor': 'Direct',
                  'offline': 'Offline'
                  }[type]
                  }}
                </label>
              </div>

            </div>

            <div *ngIf="partForm.get('sourcingType')?.invalid && partForm.get('sourcingType')?.touched"
              class="text-danger">
              Please select at least one sourcing type.
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-3">
          <button type="button" class="btn btn-outline-primary btn-sm mr-2" (click)="submitAddPart()"
            [disabled]="partForm.invalid">
            Add Part
          </button>
          <button type="button" class="btn btn-outline-primary btn-sm" (click)="activeModal.close()">Close</button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #offerPriceModal let-modal>
  <form>


<div class="modal-header custom-offer-header">
  <div class="header-full">
    <div class="title-text">
      {{ selectedSupplierData?.companyName }} - Offers
    </div>

    <div class="sub-line">
      <div class="sub-item">
        <span class="label">Currency:</span> {{ selectedSupplierData?.currency }}
      </div>
      <div class="sub-item right">
        <span class="label">Fetched:</span>
        {{ selectedSupplierData?.stored_at | date: 'dd/MM/yyyy' }}
      </div>
      <div class="sub-item">
        <span class="label">MPN:</span> {{ selectedSupplierData?.MPN }}
      </div>
      <div class="sub-item right">
        <span class="label">Manufacturer:</span>
        {{ selectedSupplierData?.manufacturer }}
      </div>
    </div>
  </div>
</div>

    <div class="col-12 grid-margin stretch-card col_pad">
      <div class="card">
        <div class="card-body">
          <div *ngIf="offerPriceListDetails?.length === 0 ">
            <div style="text-align: center;">
              <h6>No data found.</h6>
            </div>
          </div>
          <div *ngIf="offerPriceListDetails?.length > 0 " class="table-responsive card gd_main_div_mobile">
            <table class="table table-striped custom-hover">
              <thead>
                <tr>
                  <th></th>
                  <th>Quantity</th>
                  <th>Price</th>                
                  <th>Converted Price(INR)</th>
                </tr>
              </thead>
              <tbody>
                
                <tr *ngFor="let data of offerPriceListDetails, let i = index"
                  [class.selected]="selectedPriceRowIndex === i">
                  <td>
                    <input type="checkbox" [checked]="selectedPriceRowIndex === i" (change)="selectPriceRow(i)" />
                  </td>
                  <td>{{data?.quantity}}</td>
                  <td>{{data?.price}}</td>               
                  <td>{{data?.convertedPrice | number:'1.2-2'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
   
    
      <button
  *ngIf="selectedPriceRowIndex !== null && !(role === 'Engineer' && projectStatus === 'Closed')"
  type="submit"
  class="btn btn-outline-primary btn-sm"
  (click)="savePriceData()">
  Save
</button>


      <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="closeModal()">Close</button>
    </div>
  </form>
</ng-template><!-- Offline Confirmation Modal -->
<ng-template #offlineConfirmModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Confirm Update</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <p class="mb-4">Do you want to Update it in Offline</p>
  </div>
  <div class="modal-footer justify-content-center">
    <button type="button" class="btn btn-outline-primary btn-sm" (click)="confirmOfflineUpdate()">Yes</button>
    <button type="button" class="btn btn-outline-primary btn-sm" (click)="modal.dismiss()">No</button>

  </div>
</ng-template>

<div *ngIf="showPopup1" >
  <div class="modal-backdrop fade show"></div>
  <div class="modal d-block" tabindex="-1">
    <div class="modal-dialog modal-xl custom-modal-scrollbar" style="max-width:90vw;max-height:90vh;">
      <div class="modal-content p-3" style="height:80vh; display:flex; flex-direction:column;">
        <div class="modal-header">
          <h5 class="modal-title">Price History</h5>
          <button type="button" class="close" (click)="closePriceHistory()">
            <span aria-hidden="true" style="font-size: 2rem;">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- Summary Cards -->
          <div class="summary-cards d-flex justify-content-center flex-wrap mb-4 gap-4">
            <div class="card-summary">
              <div class="fw-semibold mb-1 text-secondary">Internal Part No</div>
              <div class="h5 fw-bold mb-0">{{ priceSummary?.internalPartNumber }}</div>
            </div>
            <div class="card-summary">
              <div class="fw-semibold mb-1 text-secondary">Min Price (₹)</div>
              <div class="h5 fw-bold mb-0">{{ priceSummary?.minPriceINR | number:'1.2-2' }}</div>
            </div>
            <div class="card-summary">
              <div class="fw-semibold mb-1 text-secondary">Max Price (₹)</div>
              <div class="h5 fw-bold mb-0">{{ priceSummary?.maxPriceINR | number:'1.2-2' }}</div>
            </div>
            <div class="card-summary">
              <div class="fw-semibold mb-1 text-secondary">Avg Price (₹)</div>
              <div class="h5 fw-bold mb-0">{{ priceSummary?.weightedAveragePriceINR | number:'1.2-2' }}</div>
            </div>
            <div class="card-summary">
              <div class="fw-semibold mb-1 text-secondary">Purchase Count</div>
              <div class="h5 fw-bold mb-0">{{ priceSummary?.purchaseCount }}</div>
            </div>
            <div class="card-summary">
  <div class="fw-semibold mb-1 text-secondary">Required Quantity</div>
  <div class="h5 fw-bold mb-0">{{ priceSummary?.projectQty | number:'1.2-2' }}</div>
</div>

          </div>
          <!-- PO History Table -->
        <div class="table-scroll-area">
  <table class="table table-bordered table-sm custom-hover shadow-sm bg-white" style="font-size: 15px;">
    <thead class="table-secondary text-center sticky-top sticky-header">
      <tr>
        <th (click)="onSort('poNumber')">
          PO Number
          <span *ngIf="sortColumn === 'poNumber'">
            {{ sortDirection === 'asc' ? '▲' : '▼' }}
          </span>
        </th>
        <th (click)="onSort('poDate')">
          PO Date
          <span *ngIf="sortColumn === 'poDate'">
            {{ sortDirection === 'asc' ? '▲' : '▼' }}
          </span>
        </th>
        <th (click)="onSort('projectNumber')">
          Project Name
          <span *ngIf="sortColumn === 'projectNumber'">
            {{ sortDirection === 'asc' ? '▲' : '▼' }}
          </span>
        </th>
        <th (click)="onSort('supplierName')">
          Supplier Name
          <span *ngIf="sortColumn === 'supplierName'">
            {{ sortDirection === 'asc' ? '▲' : '▼' }}
          </span>
        </th>
        <th (click)="onSort('internalPartNumber')">
          Internal Part No
          <span *ngIf="sortColumn === 'internalPartNumber'">
            {{ sortDirection === 'asc' ? '▲' : '▼' }}
          </span>
        </th>
        <th (click)="onSort('mpn')">
          MPN
          <span *ngIf="sortColumn === 'mpn'">
            {{ sortDirection === 'asc' ? '▲' : '▼' }}
          </span>
        </th>
        <th (click)="onSort('uom')">
          UOM
          <span *ngIf="sortColumn === 'uom'">
            {{ sortDirection === 'asc' ? '▲' : '▼' }}
          </span>
        </th>
        <th (click)="onSort('qty')">
          Quantity
          <span *ngIf="sortColumn === 'qty'">
            {{ sortDirection === 'asc' ? '▲' : '▼' }}
          </span>
        </th>
         <th (click)="onSort('unitPrice')">
         Unit Price
          <span *ngIf="sortColumn === 'unitPrice'">
            {{ sortDirection === 'asc' ? '▲' : '▼' }}
          </span>
        </th>
          <th (click)="onSort('currency')">
        Currency
          <span *ngIf="sortColumn === 'currency'">
            {{ sortDirection === 'asc' ? '▲' : '▼' }}
          </span>
        </th>
        <th (click)="onSort('unitPriceINR')">
           Unit Price (INR)
          <span *ngIf="sortColumn === 'unitPriceINR'">
            {{ sortDirection === 'asc' ? '▲' : '▼' }}
          </span>
        </th>
           <th (click)="onSort('landing_INR_cost')">
          Landing Cost 
          <span *ngIf="sortColumn === 'landing_INR_cost'">
            {{ sortDirection === 'asc' ? '▲' : '▼' }}
          </span>
        </th>
      
      
        <th (click)="onSort('stockAvailability')">
          Stock Availability
          <span *ngIf="sortColumn === 'stockAvailability'">
            {{ sortDirection === 'asc' ? '▲' : '▼' }}
          </span>
        </th>
        <th>Action</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let row of selectedPriceHistory">
        <td>{{ row.poNumber }}</td>
        <td>{{ row.poDate | date: 'dd-MMM-yyyy' }}</td>
        <td>{{ row.projectNumber }}</td>
        <td>{{ row.supplierName }}</td>
        <td>{{ row.internalPartNumber }}</td>
        <td>{{ row.mpn }}</td>
        <td>{{ row.uom }}</td>
        <td>{{ row.qty }}</td>
        <td>{{ row.unitPrice | number:'1.2-2'  }}</td>
      <td>{{ row.currency }}</td>
        <td>{{ row.unitPriceINR | number:'1.2-2' }}</td>
        <td>{{ row.landing_INR_cost | number:'1.2-2' }}</td>
      
        <td>{{ row.stockAvailability }}</td>
        <td class="text-center">
          <input type="checkbox" [(ngModel)]="row.isSelected" (change)="onSelectHistory(row)">
        </td>
      </tr>
    </tbody>
  </table>

  <div class="text-end mt-3" *ngIf="showSendButton">
    <button class="btn btn-primary px-4" (click)="sendSelectedHistory()">
     Update 
    </button>
  </div>
</div>

        </div>
      </div>
    </div>
  </div>
 

</div>
